import { FC, SVGProps } from "react";

const Box: FC<SVGProps<SVGSVGElement>> = (props) => {
    return <svg stroke="currentcolor" {...props}>
        <rect x={0} y={0} width={10} height={10}/>
    </svg>
};

export default Box;